/*
 * @Description: 国际化标识定义
 * @Author: 刘宝顺
 * @Date: 2024-03-01 14:52:07
 * @LastEditTime: 2024-03-19 14:25:16
 * @LastEditors: 刘宝顺
 */
/** 国际化 */
export const COUNTRY_LANG_ZH_CN = 'zh-CN';
export const COUNTRY_LANG_EN_US = 'en-US';
export const COUNTRY_LANG_TH_TH = 'th-TH';
export const COUNTRY_LANG_KO_RE = 'ko-KR';
// 类型定义，当上方语言地区标识 COUNTRY_LANG_* 更新后需同步更新下方 TCountryLangCode
export type TCountryLangCode = typeof COUNTRY_LANG_EN_US | typeof COUNTRY_LANG_KO_RE | typeof COUNTRY_LANG_TH_TH | typeof COUNTRY_LANG_ZH_CN;

// 语言code
export const LANGUAGE_CODE_CHINESE = 'zh';
export const LANGUAGE_CODE_AMERICA = 'en';
export const LANGUAGE_CODE_THAILAND = 'th';

// 国家code
export const COUNTRY_ISO_CODE_CHINA = 'CN';
export const COUNTRY_ISO_CODE_AMERICA = 'US';
export const COUNTRY_ISO_CODE_THAILAND = 'TH';
// 类型定义，当上方国家code COUNTRY_ISO_CODE_* 更新后需同步更新下方 TCountryIsoCode，便于其他地方使用
export type TCountryIsoCode = typeof COUNTRY_ISO_CODE_AMERICA | typeof COUNTRY_ISO_CODE_CHINA | typeof COUNTRY_ISO_CODE_THAILAND;
